import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { getActiveOrgGuid } from '../../common/activeOrgStorage';
import type { OrganizationContextState, OrganizationMembership } from './types';

const initialState: OrganizationContextState = {
  memberships: [],
  activeOrgGuid: getActiveOrgGuid(),
  isLoading: false,
  error: null
};

export const slice = createSlice({
  name: 'organizationContext',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    getMembershipsSuccess(state, action: PayloadAction<OrganizationMembership[]>) {
      state.isLoading = false;
      state.memberships = action.payload;
    },
    hasError(state, action: PayloadAction<string | null>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setActiveOrg(state, action: PayloadAction<string | null>) {
      state.activeOrgGuid = action.payload;
    },
    addMembership(state, action: PayloadAction<OrganizationMembership>) {
      state.memberships.push(action.payload);
    }
  }
});

export default slice.reducer;
